export const isLocalAuthEnabled = (environment = process.env) => (
  environment.NODE_ENV !== 'production' &&
  environment.REACT_APP_LOCAL_AUTH_ENABLED === 'true'
);

export const getLoginPath = (environment = process.env) => (
  isLocalAuthEnabled(environment) ? '/auth/local' : '/auth/google'
);

export const shouldStartLocalAuth = ({ environment = process.env, pathname = '/' }) => (
  isLocalAuthEnabled(environment) &&
  !pathname.startsWith('/file/') &&
  !pathname.startsWith('/file-group/')
);
